module.exports = __webpack_public_path__ + "static/media/shadow-right.6c857ada.png";